import LoginView from '@Account/views/Login.vue';
import ForgetPassword from '@Account/views/ForgetPassword.vue';
import ResetPassword from '@Account/views/ResetPassword.vue';
import AcceptInvitation from '@Account/views/AcceptInvitation.vue';
import PreferencesView from '@Account/views/PreferencesView.vue';
import StorageSettings from './views/StorageSettings.vue';
import SSOSettings from '@/features/Company/views/SSOSettings.vue';
import SSOCallback from '@Account/views/SSOCallback.vue';
import ApiKeysManagement from '@/features/Company/views/ApiKeysManagement.vue';
import ConnectAi from '@Account/views/ConnectAi.vue';
import permissions from '@Share/config/permissions';

export default [
  {
    // Consent page an AI assistant (any MCP client) sends the user to during its OAuth sign-in (AVA-560).
    path: '/connect/ai',
    name: 'connect-ai',
    component: ConnectAi,
    meta: {
      layout: 'auth-layout',
      requiresAuth: true,
      returnAfterLogin: true,
      title: 'Connect an AI assistant',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      layout: 'auth-layout',
      requiresAuth: false,
      title: 'Login',
    },
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: ForgetPassword,
    meta: {
      layout: 'auth-layout',
      requiresAuth: false,
      title: 'Forgot Password',
    },
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    component: ResetPassword,
    meta: {
      layout: 'auth-layout',
      requiresAuth: false,
      title: 'Reset Password',
    },
  },
  {
    path: '/invitations/:id/:companyId',
    name: 'accept-invitation',
    component: AcceptInvitation,
    meta: {
      layout: 'auth-layout',
      requiresAuth: false,
      title: 'Accept Invitation',
    },
  },
  {
    path: '/preferences',
    name: 'preferences',
    component: PreferencesView,
    meta: {
      layout: 'account-layout',
      requiresAuth: true,
      title: 'Preferences',
    },
  },
  {
    path: '/storage-settings',
    name: 'storage-settings',
    component: StorageSettings,
    meta: {
      layout: 'account-layout',
      requiresAuth: true,
      title: 'Storage Settings',
      permissions: [permissions.CompaniesManagement.StorageSettings],
    },
  },
  {
    path: '/sso-settings',
    name: 'sso-settings',
    component: SSOSettings,
    meta: {
      layout: 'account-layout',
      requiresAuth: true,
      title: 'SSO Settings',
      permissions: [permissions.CompanyProfile.SsoSettings],
    },
  },
  {
    path: '/api-keys',
    name: 'api-keys',
    component: ApiKeysManagement,
    meta: {
      layout: 'account-layout',
      requiresAuth: true,
      title: 'API Keys',
      permissions: [permissions.CompanyProfile.ApiKeys],
    },
  },
  {
    path: '/sso-callback',
    name: 'sso-callback',
    component: SSOCallback,
    meta: {
      layout: 'auth-layout',
      requiresAuth: false,
      title: 'SSO Login',
    },
  },
];
